import {
    Container,
    Heading,
    Stack,
    Text,
    Button,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export default function About() {
    return (
        <Container maxW={'5xl'} >
            <Stack
                textAlign={'center'}
                align={'center'}
                spacing={{ base: 8, md: 10 }}
                py={{ base: 20, md: 28 }}>
                <Heading
                    fontWeight={600}
                    fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                    lineHeight={'110%'}>
                    About{' '}
                    <Text as={'span'} color={'orange.400'}>
                        FESTIN
                    </Text>
                    <Text as={'span'} color={'blue.400'}>
                        -
                    </Text>
                    <Text as={'span'} style={{ WebkitTextStroke: "3px #4299E1" }} color={'white'}>O</Text>
                    <Text as={'span'} color={'blue.400'}>
                        -
                    </Text>
                    <Text as={'span'} color={'green.400'}>
                        Beats 12.0
                    </Text>
                </Heading>
                <Text color={'gray.500'} maxW={'3xl'} fontSize={{ base: 'sm', sm: 'sm', md: 'xl' }}
                    style={{ textAlign: 'justify' }}
                >
                    The College Annual Fest is about giving an unbridled flight to your creative instincts to soar high, finding your ground as a performer and getting to know the hidden potential that unravels itself in different hues. Festive spirit reins the participation of students coming in from different colleges to find a common platform that promises to give fillip to their confidence in more ways than one. Be it leadership, team spirit, organization, cooperation, or culture, annual fest Festin-O-Beats 12.0 cater to all with clan. You are cordially invited to join the bandwagon to make it a grand success -like always.
                </Text>
                <RouterLink to='/'>
                    <Button
                        rounded={'full'}
                        px={6}
                        colorScheme={'green'}
                        bg={'green.400'}
                        _hover={{ bg: 'green.500' }}>
                        Explore More
                    </Button>
                </RouterLink>
            </Stack>
        </Container >
    );
}
